





























import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  public modelShow = false;
  public rows: any = {};
  public shows = false;
  public content = "";
  public show(shows, row) {
    this.rows = [];
    this.rows = row;
    this.shows = shows;
    this.content = "";
    this.modelShow = true;
  }
  public submit(shows) {
    this.modelShow = false
    const arrs: any = []
    arrs.push(this.rows.id)
    if (shows) {
      this.$emit("childSubmit", shows, arrs, "");
    } else {
      this.$emit("childSubmit", shows, arrs, this.content);
    }
  }
}
